export default __webpack_public_path__ + "static/media/2.13a81479.svg";